import { TableV2Column } from 'components/Table/TableV2';
import { UseUserCalendarReturnDataItem } from '../hooks/useUserCalendar';
import { capitaliseFirstLetter } from 'utils/capitaliseFirstLetter';
export const calendarOrganizationColumns: TableV2Column<UseUserCalendarReturnDataItem>[] =
  [
    {
      name: 'Name',
      selector: (row) => row.name,
      grow: 2
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      grow: 3
    },
    {
      name: 'Reference',
      selector: (row) => row.reference ?? '-',
      grow: 2
    },
    {
      name: 'Type',
      selector: (row) => row.userType || ''
    },
    {
      name: 'Status',
      selector: (row) => (row.status ? capitaliseFirstLetter(row.status) : '')
    },
    {
      name: 'Calendar',
      selector: (row) =>
        row.provider ? capitaliseFirstLetter(row.provider) : '',
      width: '100px'
    }
  ];
